// Favorite script
const customerId = window.theme.settings.favSet.cid
const pageType = window.theme.settings.favSet.pageType
const isProductPage = pageType === 'product'
let favoritedVariantIDinDb = null
const FAV_SAVE_URL = '/apps/apibridge/integration/path/cm4gqi0ew0004slkayjb7dae1'
const FAV_GET_URL = '/apps/apibridge/integration/path/cm4i4blnz000aslkamyj05bzw'
const pdpOriginalPriceSelector = '[data-product-price]'
const pdpCurrentVariantSelector = '[data-current-variant]'
const jumboCorparateNumber = 5

/*
GET
{
    "customer": 7120971071708,
    "corporateCountry": 1
}
SAVE
{
    "favoriteProduct": {
        "ProductTargetUniqueId": "8251703787740",
        "ProductVariantTargetUniqueId": "44348984066268",
        "CustomerTargetUniqueId": 7120971071708,
        "OldPrice": 2000.00,
        "corporateCountry": 1
    }
}
*/

function isLoggedIn(){
  if(customerId) return true
  else return false
}

function addDecimal(str) {
  if(!str) return ""
  if (str.length < 3) {
      return str;
  }
  return str.slice(0, -2) + '.' + str.slice(-2);
}

function getTheGTMPageType(){
  let GTMPageType;
  switch (pageType) {
    case 'collection':
      GTMPageType = "Listeleme"
      break;
    case 'index':
      GTMPageType = "Anasayfa"
      break;
    case 'search':
      GTMPageType = "Search"
      break;
    default:
      GTMPageType = "Anasayfa"
      break;
  }
  return GTMPageType
}

function pushToDataLayer(svgIcon, eventType) {
  const dataLayerObject = {
      event: eventType,
      ecommerce: {
          currency: "TRY",
          value: svgIcon.dataset.gtmprice,
          items: [{
              item_name: svgIcon.dataset.favtitle,
              item_id: svgIcon.dataset.variantfavid,
              price: +svgIcon.dataset.favcompareprice > 0 ? 
                addDecimal(svgIcon.dataset.favcompareprice) : svgIcon.dataset.gtmprice,
              discount: +svgIcon.dataset.favcompareprice > 0 ? 
                addDecimal((+svgIcon.dataset.favcompareprice - +svgIcon.dataset.favprice).toString()) : '0.00',
              item_brand: svgIcon.dataset.favbrand || 'Jumbo',
              item_category: svgIcon.dataset.favcategory1,
              item_category2: svgIcon.dataset.favcategory2,
              item_category3: svgIcon.dataset.favcategory3,
              item_category4: svgIcon.dataset.favcategory4,
              item_category5: "",
              quantity: 1,
              item_list_id: getTheGTMPageType(),
              item_list_name: svgIcon.dataset.favlistname,
              item_variant: svgIcon.dataset.favvariant,
              item_first_price: addDecimal(svgIcon.dataset.favfirstprice),
              item_sale_rate: svgIcon.dataset.favpercentoff ? 
                  `%${svgIcon.dataset.favpercentoff}` : "0%",
              item_stock: svgIcon.dataset.favitemstock,
              item_image: svgIcon.dataset.favimage,
              item_previous_id: svgIcon.dataset.favoldproductcode
          }]
      }
  };
  dataLayer.push(dataLayerObject);
}

async function setUserFavorite(data, svgIcon) {
  svgIcon.parentNode.classList.add('svg-loading');
  delete data.favoriteProduct.Data;
  let success = false;
  try {
    const res = await fetch(FAV_SAVE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
    const response = await res.json();
    success = response.success;
  } catch (e) {
    console.warn("setUserFavorite ", e);
  } finally {
    svgIcon.parentNode.classList.remove('svg-loading');
    if (success) {
        const realSvg = svgIcon.tagName.toLowerCase() === "svg" 
          ? svgIcon 
          : svgIcon.firstElementChild
        const isAdd = realSvg.classList.contains('fill-black'); // fill-black toggled in prev func
        pushToDataLayer(realSvg, isAdd ? 'add_to_wishlist' : 'remove_from_wishlist');
    }
  }
}
function handleSessionStorage(key,data){
  if(!customerId) return

  const favorites = sessionStorage.getItem(key)
  if(favorites && favorites !== 'undefined'){
    const favoritesArray = JSON.parse(favorites);

    const dataKey = data.favoriteProduct.ProductTargetUniqueId
    let hasData = false
    for (let i=0; i < favoritesArray.length; i++) {
      const dataId = favoritesArray[i].productTargetUniqueId || favoritesArray[i].ProductTargetUniqueId
      if (dataId == dataKey) {
        favoritesArray.splice(i, 1);
        hasData = true
      }
    }
    if(!hasData) {
      favoritesArray.push(data.favoriteProduct)
    }
    sessionStorage.setItem(key, JSON.stringify(favoritesArray));
  } else {
    sessionStorage.setItem(key, JSON.stringify([data.favoriteProduct]));
  }
}
function handleClickFavorite (e,svgEl) {
    if (window.Flutter) {
      window.Flutter.postMessage(svgEl.dataset.productfavid);
      return
    }
    const isLogin = isLoggedIn()
    if(!isLogin) {
      window.location.assign('/account/login?return_url=%2Fpages%2Ffavoriler')
      return
    }
    if(pageType === 'cart'){
        if(e.target.classList.contains('fill-black')) return
        svgEl = e.detail.customCurrentTarget
    }
    e.preventDefault()
    const productData = {
        title: svgEl.dataset.favtitle,
        handle: svgEl.dataset.favhandle,
        img: svgEl.dataset.favimg,
        price: svgEl.dataset.favprice,
        cprice: svgEl.dataset.favcompareprice,
        vname: svgEl.dataset.favvariantname
    }
    const data = {
        favoriteProduct:{
            ProductTargetUniqueId : svgEl.dataset.productfavid,
            ProductVariantTargetUniqueId : svgEl.dataset.variantfavid,
            CustomerTargetUniqueId : customerId,
            corporateCountry: jumboCorparateNumber,
            oldPrice: svgEl.dataset.favprice,
            Data: JSON.stringify(productData)
        }
    }
    svgEl.classList.toggle('fill-black')

    setUserFavorite(data,svgEl.parentNode)
    handleSessionStorage('favoriteItems',data)
}
function handleFlutterWebviewClick({ customerData, productId }){
  try {
    const favoritedElement = document.querySelector(`[data-productfavid="${+productId}"]`)
    if(favoritedElement){
      const productData = {
        title: favoritedElement.dataset.favtitle,
        handle: favoritedElement.dataset.favhandle,
        img: favoritedElement.dataset.favimg,
        price: favoritedElement.dataset.favprice,
        cprice: favoritedElement.dataset.favcompareprice,
        vname: favoritedElement.dataset.favvariantname
      }
      const data = {
          favoriteProduct:{
              ProductTargetUniqueId : favoritedElement.dataset.productfavid,
              ProductVariantTargetUniqueId : favoritedElement.dataset.variantfavid,
              CustomerTargetUniqueId : Number(customerData),
              corporateCountry: jumboCorparateNumber,
              oldPrice: favoritedElement.dataset.favprice,
              Data: JSON.stringify(productData)
          }
      }
      favoritedElement.classList.toggle('fill-black')
      setUserFavorite(data,favoritedElement.parentNode)
      handleSessionStorage('favoriteItems',data)
    }
  } catch (error) {
      console.warn(error)
      if (window.Flutter) {
          window.Flutter.postMessage(JSON.stringify(error));
          return
      }
  }
}
function getVariantParams() {
  const params = new URLSearchParams(window.location.search);
  return +params.get('variant') || +document.querySelector('[data-current-variant]').getAttribute('data-current-variant');
}
function handleClickPDPFavorite(e,svgEl) {
    const isLogin = isLoggedIn()
    if(!isLogin) {
      window.location.assign('/account/login?return_url=%2Fpages%2Ffavoriler')
      return
    }
    const isFavorited = favoritedVariantIDinDb === null ? false : true
    const productData = {
        title: svgEl.dataset.favtitle,
        handle: svgEl.dataset.favhandle,
        img: svgEl.dataset.favimg,
        price: svgEl.dataset.favprice,
        cprice: svgEl.dataset.favcompareprice,
        vname: svgEl.dataset.favvariantname
    }
    const data = {
        favoriteProduct: {
            ProductTargetUniqueId : svgEl.dataset.productfavid,
            ProductVariantTargetUniqueId : svgEl.dataset.variantfavid,
            CustomerTargetUniqueId : customerId,
            oldPrice: svgEl.dataset.favprice,
            corporateCountry: jumboCorparateNumber
        }
    }
    isFavorited
    ? handleDeleteFavorite(data, svgEl)
    : handleAddFavorite(data,productData,svgEl)
    svgEl.classList.toggle('fill-black')
}
function handleAddFavorite(data,productData,svgIcon){
  const currentVariant = getVariantParams()
  const currentPrice = Number(document.querySelector(pdpOriginalPriceSelector).innerText.replace(/\D/g, ""))
  let variantStr = ""
  const currentVariantNames = document.querySelectorAll(pdpCurrentVariantSelector)
  currentVariantNames.forEach((item,i) => {
    variantStr += item.innerText;
    i === 0 ? variantStr += ' / ' : null;
  })

  productData.price = currentPrice
  productData.vname = variantStr
  data.favoriteProduct.ProductVariantTargetUniqueId = currentVariant
  data.favoriteProduct.Data = JSON.stringify(productData)

  favoritedVariantIDinDb = currentVariant
  if(!customerId) {
    const favorites = localStorage.getItem('favoriteItems')
    const arr = favorites ? JSON.parse(favorites) : []

    data.favoriteProduct.ProductTargetUniqueId = data.favoriteProduct.ProductTargetUniqueId
    arr.push(data)
    localStorage.setItem('favoriteItems',JSON.stringify(arr))
    return
  }
  // add to sessionStorage
  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  const sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
  sessionArr.push(data.favoriteProduct)
  sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

  setUserFavorite(data,svgIcon)
}
function handleDeleteFavorite(data,svgIcon){
  data.favoriteProduct.ProductVariantTargetUniqueId = favoritedVariantIDinDb
  favoritedVariantIDinDb = null
  if(!customerId) {
    const favorites = localStorage.getItem('favoriteItems')
    let arr = favorites ? JSON.parse(favorites) : []
    arr = arr.filter(item => item.favoriteProduct.ProductTargetUniqueId != data.favoriteProduct.ProductTargetUniqueId)
    localStorage.setItem('favoriteItems',JSON.stringify(arr))
    return
  }
  // delete from session
  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  let sessionArr = sessionFavorites ? JSON.parse(sessionFavorites) : []
  sessionArr = sessionArr.filter(item => {
    const itemId = item.ProductTargetUniqueId || item.productTargetUniqueId
    return itemId != data.favoriteProduct.ProductTargetUniqueId
  })
  sessionStorage.setItem('favoriteItems',JSON.stringify(sessionArr))

  setUserFavorite(data,svgIcon)
}
function handleFillFavoriteIcons(data,allFavoriteIcons,isSession = false) {
  if (!data || !data.length) {
    allFavoriteIcons.forEach(icon => icon.parentNode.classList.remove('svg-loading'))
    return;
  }

  let userFavoriteMap
  if(!customerId) {
      data = data.map(item => item.favoriteProduct)
    userFavoriteMap = new Map(data.map(item => [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]));
  } else if(isSession) {
    userFavoriteMap = new Map(data.map(item => {
      if(item['guid']) return [item.productTargetUniqueId, item.productVariantTargetUniqueId]
      return [+item.ProductTargetUniqueId, +item.ProductVariantTargetUniqueId]
    }));
  } else {
    userFavoriteMap = new Map(data.map(item => [item.productTargetUniqueId, item.productVariantTargetUniqueId]));
  }
  requestAnimationFrame(() => {
    allFavoriteIcons.forEach(icon => {
      const id = Number(icon.dataset.productfavid);
      if (userFavoriteMap.has(id)) {
        const variantId = userFavoriteMap.get(id)
        if(isProductPage && icon.hasAttribute('data-productselector')) {
            favoritedVariantIDinDb = variantId;
        }
        icon.classList.add('fill-black');
        icon.dataset.variantfavid = variantId;
      }
      icon.parentNode.classList.remove('svg-loading')
    });
  });
}
async function getUserFavorites() {
  if(!customerId) return
  const allFavoriteIcons = document.querySelectorAll('[data-favorite-item]');
  if(!allFavoriteIcons) return

  const sessionFavorites = sessionStorage.getItem('favoriteItems')
  if(sessionFavorites && sessionFavorites !== 'undefined'){
  const parsedSessionFavorites = JSON.parse(sessionFavorites)
    if(parsedSessionFavorites.length) {
      handleFillFavoriteIcons(parsedSessionFavorites,allFavoriteIcons,true)
      return
    }
  }

  try {
    const res = await fetch(FAV_GET_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({customer : customerId,  corporateCountry: jumboCorparateNumber }) });
    const response = await res.json()
    if(!response.success || !response.data.body) return
    const parsedData = JSON.parse(response.data.body)
    if(!parsedData.isSuccess) return
    if(parsedData?.data){
        sessionStorage.setItem('favoriteItems',JSON.stringify(parsedData.data))
        handleFillFavoriteIcons(parsedData.data,allFavoriteIcons)
    }
  } catch(e) {
    console.error("getUserFavorites", e)
  }

}
window.addEventListener("DOMContentLoaded", getUserFavorites)
